var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "slide" } }, [
    _c("div", { staticClass: "bg-surface-secondary w-100" }, [
      _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
        _c("div", { staticClass: "container-fluid py-4 border-bottom" }, [
          _c("div", { staticClass: "row align-items-center" }, [
            _c("div", { staticClass: "col" }, [
              _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
                _c("div", [
                  _c("button", {
                    staticClass: "btn-close text-xs",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.$router.go(-1)
                      },
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "vr opacity-20 my-1" }),
                _vm._v(" "),
                _c("h1", { staticClass: "h4 ls-tight" }, [
                  _vm._v("Actualizar Ruta de entrega"),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-auto" }, [
              _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-h btn-success px-3",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.UPDATE()
                      },
                    },
                  },
                  [
                    _vm.count == 1
                      ? _c(
                          "div",
                          {
                            staticClass: "spinner-border spinner-border-sm",
                            attrs: { role: "status" },
                          },
                          [
                            _c("span", { staticClass: "sr-only" }, [
                              _vm._v("Loading..."),
                            ]),
                          ]
                        )
                      : _c("span", [_vm._v("Guardar cambios")]),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
        _c("div", { staticClass: "container-fluid vstack gap-5" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [_vm._v("Ruta")]),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.route_id ? "is-invalid" : "",
                    attrs: {
                      items: _vm.routes,
                      "item-text": function (row) {
                        return row.code + " - " + row.name
                      },
                      "item-value": "id",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.data.route_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "route_id", $$v)
                      },
                      expression: "data.route_id",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.route_id, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Chofer"),
                  ]),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.driver_id ? "is-invalid" : "",
                    attrs: {
                      items: _vm.drivers,
                      "item-text": function (row) {
                        return row.type + " - " + row.name
                      },
                      "item-value": "id",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.data.driver_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "driver_id", $$v)
                      },
                      expression: "data.driver_id",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.driver_id, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group mb-2" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Unidad"),
                  ]),
                  _vm._v(" "),
                  _c("v-autocomplete", {
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.unit_id ? "is-invalid" : "",
                    attrs: {
                      items: _vm.units,
                      "item-text": "name",
                      "item-value": "id",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.data.unit_id,
                      callback: function ($$v) {
                        _vm.$set(_vm.data, "unit_id", $$v)
                      },
                      expression: "data.unit_id",
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.unit_id, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-lg-6" }, [
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("small", { staticClass: "input-title" }, [
                    _vm._v("Fecha"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-menu",
                    {
                      attrs: {
                        "close-on-content-click": false,
                        transition: "scale-transition",
                        "offset-y": "",
                        "min-width": "auto",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function (ref) {
                            var on = ref.on
                            var attrs = ref.attrs
                            return [
                              _c(
                                "v-text-field",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass:
                                        "form-control form-control-sm",
                                      attrs: {
                                        value: _vm.data.date,
                                        "hide-details": "",
                                        readonly: "",
                                        clearable: "",
                                      },
                                      on: {
                                        "click:clear": function ($event) {
                                          _vm.data.date = ""
                                        },
                                      },
                                    },
                                    "v-text-field",
                                    attrs,
                                    false
                                  ),
                                  on
                                )
                              ),
                            ]
                          },
                        },
                      ]),
                      model: {
                        value: _vm.menu_date,
                        callback: function ($$v) {
                          _vm.menu_date = $$v
                        },
                        expression: "menu_date",
                      },
                    },
                    [
                      _vm._v(" "),
                      _c("v-date-picker", {
                        attrs: { "no-title": "", scrollable: "" },
                        on: {
                          input: function ($event) {
                            _vm.menu_date = false
                          },
                        },
                        model: {
                          value: _vm.data.date,
                          callback: function ($$v) {
                            _vm.$set(_vm.data, "date", $$v)
                          },
                          expression: "data.date",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }